"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SortArrows = exports.SortArrowUp = exports.SortArrowDown = void 0;
var _react = _interopRequireDefault(require("react"));
var _toLower = _interopRequireDefault(require("lodash/fp/toLower"));
var SortArrowUp = function SortArrowUp() {
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: 'sort-icon sort-asc'
  });
};
exports.SortArrowUp = SortArrowUp;
var SortArrowDown = function SortArrowDown() {
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: 'sort-icon sort-desc'
  });
};
exports.SortArrowDown = SortArrowDown;
var SortArrows = function SortArrows(_ref) {
  var direction = _ref.direction;
  return /*#__PURE__*/_react["default"].createElement("span", {
    className: "sort-arrows sort-".concat((0, _toLower["default"])(direction))
  });
};
exports.SortArrows = SortArrows;